var SectionFilterAnchor = {};
SectionFilterAnchor.init = function () {
  var navHeight = $('#js-nav-menu').height();
  var spacing;
  if ($('body').hasClass('admin-bar')) {
    spacing = navHeight + 32;
  } else {
    spacing = navHeight;
  }
  $('.section-filter-action').on('click', function (event) {
    if (this.hash !== '') {
      event.preventDefault();
      var hash = this.hash;
      if (hash.length) {
        var new_scroll_position = $(hash).offset().top - spacing;
        $('html, body').animate({
          scrollTop: new_scroll_position
        }, 500, 'linear');
      }
    }
  });
};
$(window).on("load", function () {
  SectionFilterAnchor.init();
});


// WEBPACK FOOTER //
// ./scripts/components/section-filter-anchor.js